import { SET_GRD_REQ_DOC_DATA, RESET_GRD_REQ_DOC_DATA, SET_GRD_REQ_OPEN, SET_GRD_REQ_STD_DATA, SET_GRD_REQ_MODE } from '../actionTypes'

const INIT_PROTOTYPE_STATE = {
  grd_document_id: null,
  submit_status: null,
  isOpenPage: null,
}
const initialState = JSON.parse(localStorage.getItem('grd_document_data')) || {}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_GRD_REQ_DOC_DATA:
      let getPayload = {
        grd_document_id: action.payload?.grd_document_id,
        submit_status: action.payload?.hadChange
          ? action.payload?.submit_status == '80602'
            ? '80601'
            : action.payload?.submit_status == '80601'
            ? '80602'
            : action.payload?.defaultSubmitStatus
          : action.payload?.submit_status,
      }
      localStorage.setItem('grd_document_data', JSON.stringify({ ...state, ...getPayload }))
      return { ...state, ...getPayload }

    case SET_GRD_REQ_OPEN:
      let getIsOpen = {
        isOpenPage: action.payload?.isOpenPage,
      }
      localStorage.setItem('grd_document_data', JSON.stringify({ ...state, ...getIsOpen }))
      return { ...state, ...getIsOpen }

    case SET_GRD_REQ_STD_DATA:
      let getStdData = {
        stdId: action.payload?.stdId,
      }
      localStorage.setItem('grd_document_data', JSON.stringify({ ...state, ...getStdData }))
      return { ...state, ...getStdData }

    case SET_GRD_REQ_MODE:
      let getMode = {
        mode: action.payload?.mode,
      }
      localStorage.setItem('grd_document_data', JSON.stringify({ ...state, ...getMode }))
      return { ...state, ...getMode }

    case RESET_GRD_REQ_DOC_DATA:
      localStorage.removeItem('grd_document_data')
      return {}

    default:
      return state
  }
}
